"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SapphireCoreStorageFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var SapphireCoreStorageFactory = /** @class */ (function (_super) {
    __extends(SapphireCoreStorageFactory, _super);
    function SapphireCoreStorageFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    SapphireCoreStorageFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    SapphireCoreStorageFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    SapphireCoreStorageFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    SapphireCoreStorageFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    SapphireCoreStorageFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return SapphireCoreStorageFactory;
}(contracts_1.ContractFactory));
exports.SapphireCoreStorageFactory = SapphireCoreStorageFactory;
var _abi = [
    {
        constant: true,
        inputs: [],
        name: "assessor",
        outputs: [
            {
                internalType: "contract ISapphireAssessor",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "borrowIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "collateralAsset",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "feeCollector",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "highCollateralRatio",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "indexLastUpdate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "interestRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "interestSetter",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "liquidationArcRatio",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "liquidationUserRatio",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "lowCollateralRatio",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "oracle",
        outputs: [
            {
                internalType: "contract ISapphireOracle",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "pauseOperator",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "precisionScalar",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "syntheticAsset",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "totalBorrowLimit",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "totalBorrowed",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "totalCollateral",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "vaultBorrowMaximum",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "vaultBorrowMinimum",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "vaults",
        outputs: [
            {
                internalType: "uint256",
                name: "collateralAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "borrowedAmount",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "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";
